import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { ConsultarAsociadoRequest } from '../../models/cotizador-contratante/consultar-asociado/request/consultar-asociado-request.model';
import { ConsultarAsociadoResponse } from '../../models/cotizador-contratante/consultar-asociado/response/consultar-asociado-response.model';
import { URL_MAP } from '../../shared/urlMap';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConsultarAsociadoService {
  private readonly apiUrl = `${environment.HOST}${URL_MAP.API.CONSULTAR_ASOCIADO}`;

  private static readonly NOMBRE_CLAVE = 'CotConsultarAsociadoCoop';

  constructor(private httpClient: HttpClient) { }

  /**
   * Construye el request a partir del tipo y número de documento.
   */
  static buildRequest(ptyTipoDocumento: string, ptyDocumento: string): ConsultarAsociadoRequest {
    return {
      nombreClave: ConsultarAsociadoService.NOMBRE_CLAVE,
      jsonParametros: JSON.stringify({
        pty_tipo_documento: ptyTipoDocumento,
        pty_documento: ptyDocumento
      })
    };
  }

  consultarAsociado(request: ConsultarAsociadoRequest): Observable<ConsultarAsociadoResponse> {
    return this.httpClient.post<ConsultarAsociadoResponse>(this.apiUrl, request).pipe(
      catchError(error => {
        console.error('Error en consultarAsociado: ', error);
        return throwError(() => new Error(error?.message || 'Error al consultar asociado'));
      })
    );
  }
}
